import React, { Children } from 'react';
import { motion } from 'framer-motion';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const statVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function StatsSection() {
  return <section className="w-full py-16 md:py-20 px-4 sm:px-6 bg-surface border-y border-border" data-id="element-235">
      <div className="max-w-5xl mx-auto" data-id="element-236">
        <motion.p className="text-gold/70 text-xs sm:text-sm font-bold tracking-widest uppercase text-center mb-10 md:mb-12" initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5
      }} data-id="element-237">
          RESULTADOS DEL SISTEMA A.C.E.™
        </motion.p>

        <motion.div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-0 md:divide-x md:divide-border" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-60px'
      }} data-id="element-238">
          <motion.div variants={statVariants} className="text-center px-4 md:px-6" data-id="element-239">
            <p className="text-gold text-3xl sm:text-4xl md:text-5xl font-extrabold mb-2" data-id="element-240">
              +$2,400
            </p>
            <p className="text-muted text-sm sm:text-base leading-snug" data-id="element-241">
              Valor promedio por mudanza gestionada
            </p>
          </motion.div>

          <motion.div variants={statVariants} className="text-center px-4 md:px-6" data-id="element-242">
            <p className="text-gold text-3xl sm:text-4xl md:text-5xl font-extrabold mb-2" data-id="element-243">
              87%
            </p>
            <p className="text-muted text-sm sm:text-base leading-snug" data-id="element-244">
              Reducción de No-Shows con depósito automático
            </p>
          </motion.div>

          <motion.div variants={statVariants} className="text-center px-4 md:px-6" data-id="element-245">
            <p className="text-gold text-3xl sm:text-4xl md:text-5xl font-extrabold mb-2" data-id="element-246">
              3–5x
            </p>
            <p className="text-muted text-sm sm:text-base leading-snug" data-id="element-247">
              Más mudanzas confirmadas en los primeros 90 días
            </p>
          </motion.div>

          <motion.div variants={statVariants} className="text-center px-4 md:px-6" data-id="element-248">
            <p className="text-gold text-3xl sm:text-4xl md:text-5xl font-extrabold mb-2" data-id="element-249">
              12
            </p>
            <p className="text-gold/60 text-lg font-semibold -mt-1 mb-1" data-id="element-250">
              meses
            </p>
            <p className="text-muted text-sm sm:text-base leading-snug" data-id="element-251">
              Clientes activos todo el año, no solo en verano
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}